import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableHomePage2 = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableHomePage2);
};
